// extracted by mini-css-extract-plugin
export default {"logo":"hotel_logo_logo__vKyrL","logoContainer":"hotel_logo_logoContainer__IZeTj"};